import React from 'react';
import { ClockIcon } from 'lucide-react';
type LogoProps = {
  tone?: 'light' | 'dark';
  className?: string;
};
export function Logo({
  tone = 'light',
  className = ''
}: LogoProps) {
  const isDark = tone === 'dark';
  return <span className={`inline-flex items-center gap-2 ${className}`} data-id="element-44" data-mp="3qaw2usz480au">
      <span className={`flex h-9 w-9 items-center justify-center rounded-xl ${isDark ? 'bg-white/15 text-white' : 'bg-rose-mist text-rose'}`} data-id="element-45" data-mp="3v84pp6v7ksif">
        <ClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-46" data-mp="rrxiwrhhyf5f" />
      </span>
      <span className="flex flex-col leading-none" data-id="element-47" data-mp="rr5y8bpfu1tx">
        <span className={`font-display text-[13px] font-bold tracking-tight ${isDark ? 'text-white/70' : 'text-teal'}`} data-id="element-48" data-mp="dsxwzrldcecy">
          5-MIN
        </span>
        <span className={`font-display text-[17px] font-bold leading-none tracking-tight ${isDark ? 'text-white' : 'text-rose'}`} data-id="element-49" data-mp="2yhvn9dqw72ov">
          MENOPAUSE
          <sup className="text-[9px]" data-id="element-50" data-mp="1euhw86vfq6c2">™</sup>
        </span>
      </span>
    </span>;
}